import { useEffect, useState } from 'react';

export default function MapSyncStatus({ provider, connectionStatus, isNetworkSynced, isLoggedIn, recoveryNotice, recoveredFromDevice = false, readOnly = false }) {
  const [pending, setPending] = useState(0);
  const [online, setOnline] = useState(() => typeof navigator === 'undefined' || navigator.onLine);
  useEffect(() => {
    setPending(provider?.unsyncedChanges || 0);
    if (!provider) return undefined;
    const update = ({ number }) => setPending(number);
    provider.on('unsyncedChanges', update);
    return () => provider.off('unsyncedChanges', update);
  }, [provider]);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  let label;
  let detail;
  let attention = false;
  if (!isLoggedIn) {
    label = 'Not saved to an account';
    detail = 'Changes stay in this tab. Sign in to save your map.';
  } else if (recoveryNotice) {
    label = 'Changes need review';
    detail = 'Review the recovery message before closing this map.';
    attention = true;
  } else if (!online || connectionStatus === 'disconnected') {
    label = online ? 'Connection lost' : 'Offline';
    detail = readOnly ? 'Reconnect to see the latest changes.' : `${recoveredFromDevice ? 'Recovered from this device. ' : ''}Waiting to sync. Keep this tab open until you reconnect.`;
    attention = true;
  } else if (connectionStatus !== 'connected' || !isNetworkSynced) {
    label = 'Connecting…';
    detail = 'Waiting for the map to sync with the server.';
  } else if (pending > 0) {
    label = 'Syncing changes…';
    detail = 'Waiting for the server to acknowledge your changes. Keep this tab open.';
  } else {
    label = readOnly ? 'View only · up to date' : 'Up to date';
    detail = 'Connected. The server has acknowledged all changes sent from this tab.';
  }
  return (
    <div className={`mind-map-sync-status${attention ? ' mind-map-sync-status--attention' : ''}`}
      role="status" aria-live="polite" aria-atomic="true" aria-label="Map sync status"
      title={detail} data-export-ignore="true">
      <span>{label}</span>
      {(attention || !isLoggedIn) && <span className="mind-map-sync-status__detail">{detail}</span>}
    </div>
  );
}
